// @flow
import styled, { css } from 'styled-components';
import { below } from '../../assets/css/media';
import { PlayerTableCell } from '../';

export const TradeCell = styled.div`
	background: #fff;
	display: flex;
	align-items: center;
	${below.desktop`
		${css`
			width: 100%;
			.player-avatar {
				display: none
			}
			${PlayerTableCell} {
				min-width: 100px;
				flex-basis: 75%;
			}
		`}
	`}
`;

export default TradeCell;


// WEBPACK FOOTER //
// ./src/components/Trades/TradeCell.js